import { ScaffoldingData } from "../ScaffoldingData";
import { ScaffoldingFile } from "../ScaffoldingFile";
import { isDefaultKtImport } from "./util/defaultImports";

export interface KtFile extends ScaffoldingFile {
  package: string;
  imports: Set<string>;
  declarations: string[];
}

export function ktFile(data: ScaffoldingData): KtFile {
  return {
    package: data.currentPackage ?? "",
    imports: new Set<string>(),
    declarations: [],
    getContent: ktFileContent,
  };
}

function ktFileContent(this: KtFile): string {
  return (
    [
      // Package
      this.package && `package ${this.package}`,

      // Imports
      Array.from(this.imports)
        .filter((i) => !isDefaultKtImport(i))
        .sort()
        .map((i) => `import ${i}`)
        .join("\n"),

      // Declarations
      ...this.declarations,
    ]
      .filter((s) => s)
      .join("\n\n") + "\n"
  );
}
